module.exports = __webpack_public_path__ + "img/rank-1.1.d2e46aec.svg";